import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = {
  key: 0,
  class: "text-danger fs-md-12"
}
const _hoisted_6 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "row mt-3" }
const _hoisted_10 = { class: "col-md-2" }
const _hoisted_11 = { class: "form-group mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
        _createElementVNode("h5", { class: "text-black fw-semibold mb-0" }, "Monnaies/Quantités")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("label", {
          for: "caisse",
          class: "text-black fw-semibold me-2"
        }, "Caisse :", -1)),
        _createVNode(_component_Multiselect, {
          modelValue: _ctx.caisse,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.caisse) = $event)),
          options: _ctx.caisseOptions,
          "preserve-search": true,
          multiple: false,
          searchable: true,
          placeholder: "Sélectionner une caisse",
          label: "label",
          "track-by": "value",
          class: "form-control shadow-none fs-md-14 text-black",
          style: {"width":"300px"},
          onChange: _ctx.handleCaisseChange
        }, null, 8, ["modelValue", "options", "onChange"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.caisseOptions.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Aucune caisse ouverte disponible. "))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { scope: "col" }, "Monnaie"),
                  _createElementVNode("th", { scope: "col" }, "Quantité"),
                  _createElementVNode("th", { scope: "col" }, "Montant")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.monnaiesDisponibles, (monnaie, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(monnaie.libelle), 1),
                    _createElementVNode("td", null, _toDisplayString(monnaie.qteMonnaie), 1),
                    _createElementVNode("td", null, _toDisplayString(monnaie.montant), 1)
                  ]))
                }), 128)),
                (_ctx.monnaiesDisponibles.length === 0 && _ctx.caisse)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_8, _cache[4] || (_cache[4] = [
                      _createElementVNode("td", {
                        colspan: "3",
                        class: "text-center text-danger fs-md-12"
                      }, " Aucune monnaie disponible pour cette ouverture. ", -1)
                    ])))
                  : _createCommentVNode("", true)
              ])
            ])
          ])),
      _createElementVNode("div", _hoisted_9, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-md-10" }, null, -1)),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-label fw-semibold mb-1 text-start d-block" }, " Montant Total ", -1)),
            _withDirectives(_createElementVNode("input", {
              type: "number",
              class: "form-control form-control-sm shadow-none text-start",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.montantTotal) = $event)),
              readonly: ""
            }, null, 512), [
              [
                _vModelText,
                _ctx.montantTotal,
                void 0,
                { number: true }
              ]
            ])
          ])
        ])
      ])
    ])
  ]))
}